module.exports = __webpack_public_path__ + "static/img/4_sel@2x.c52c733f.png";